import { Tier } from 'features/premium/entities';
export const getProductName = (subscription) => {
    switch (subscription?.tier) {
        case Tier.plus:
            return 'Emma Plus';
        case Tier.pro:
            return 'Emma Pro';
        case Tier.ultimate:
            return 'Emma Ultimate';
        default:
            return 'Emma';
    }
};
